import React, { useState } from "react";
import DeviceContext from "../../../service/indentifyDevice";
import { Idevice } from "../../../types/device";
import ObCheckbox from "../../orderBook/generic/obCheckbox";
import Toggle from "../../../generic/toggle";
import EdButton from "../../../generic/edButton";
import { HPos2DGroupBy } from "../../../service/position/positionGroupByHelper";
import { parsedToken } from "../../../service/storageHelper";
import { PositionExcComb } from "./../positionConstants";
import "../../../../assets/scss/components/generic/filter.scss";

export interface PositionFilterProps {
	data: Array<Array<any>>; // data to be filtered
	onFilter: (filteredData: Array<Array<any>>) => void; // function to be called on clicking of checkbox
	filterInputParams: IFilterInputParams;
	tglClick: (toggle: boolean) => void;
}

interface ICheckboxState {
	value: string;
	isChecked: boolean;
}

export interface IFilterInputParams {
	isToggleOn: boolean;
	showOpenOrderTgl: boolean;
}

const PositionFilter: React.FC<PositionFilterProps> = (props) => {
	//setting state initially as false
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [isAllSelected, setIsAllSelected] = useState(true);

	const deviceState: Idevice = DeviceContext();
	const pToken: any = parsedToken();
	let filterDropDownOption: Array<ICheckboxState> = [];
	if (pToken) {
		switch (pToken.accType) {
			case "EQ":
				filterDropDownOption = [
					{ value: "Equity", isChecked: true },
					{ value: "Derivatives", isChecked: true }
				];
				break;
			case "COMEQ":
				filterDropDownOption = [
					{ value: "Equity", isChecked: true },
					{ value: "Derivatives", isChecked: true },
					{ value: "Commodity", isChecked: true }
				];
				break;
		}
	}

	// setting checkboxes values
	const [checkboxesState, setcheckboxesState] = useState(filterDropDownOption);

	//event to be performed on onChecked
	function onChecked(index: number) {
		const tempCheckboxesState = [...checkboxesState];

		const filteredData = groupData(props.data[0], props.filterInputParams.isToggleOn);

		// if all orders checkbox is clicked
		if (index === -1) {
			!deviceState.isMobile && props.onFilter(isAllSelected ? [[]] : filteredData);
			setIsAllSelected(!isAllSelected);
			setcheckboxesState(tempCheckboxesState.map((tempCheckboxState) => ({ ...tempCheckboxState, isChecked: !isAllSelected })));
			return;
		}

		// if any other checkbox is clicked
		const currentCheckbox = { ...tempCheckboxesState[index] };

		currentCheckbox.isChecked = !checkboxesState[index].isChecked;
		tempCheckboxesState[index] = currentCheckbox;
		//set all selected flag if all the checkboxes are enabled
		setIsAllSelected(tempCheckboxesState.filter((tempCheckboxState) => tempCheckboxState.isChecked).length === tempCheckboxesState.length);
		if (!tempCheckboxesState.find((tempCheckboxState) => tempCheckboxState.isChecked)) {
			// if all checkboxes are not selected
			!deviceState.isMobile && props.onFilter(!isAllSelected ? [[]] : filteredData);
		} else {
			// if any checkbox is selected
			!deviceState.isMobile && props.onFilter(filterData(filteredData, tempCheckboxesState));
		}
		setcheckboxesState(tempCheckboxesState);
	}

	//event to be performed on onSwitchOnOff
	function onSwitchOnOff() {
		let filteredData;
		if (props.filterInputParams.isToggleOn) {
			// now toggle is off
			filteredData = filterData(props.data, checkboxesState);
		} else {
			// now toggle is on
			// group the data
			filteredData = groupData(props.data[0], true);
			filteredData = !isAllSelected ? filterData(filteredData, checkboxesState) : filteredData;
		}

		props.onFilter(filteredData);
		props.tglClick && props.tglClick(!props.filterInputParams.isToggleOn);
	}

	/**
	 * This function groups open/pending and other data separately
	 * @param data array of data to be grouped
	 */
	function groupData(data: Array<any>, isToggleOn: boolean): Array<Array<any>> {
		if (isToggleOn) {
			// if toggle is switched on, then group the data
			return HPos2DGroupBy(data);
			// return [data];
		} else {
			// if toggle is switched off then return the initial data in 2D form
			return [data];
		}
	}

	function filterData(data: Array<Array<any>>, checkboxesState: Array<ICheckboxState>): Array<Array<any>> {
		return data.map((group) => {
			return group.filter((d) => {
				if (checkboxesState.length && !checkboxesState.find((checkboxState) => checkboxState.isChecked)) {
					// if no checkbox is checked
					return false;
				} else if (!isAllSelected) {
					return !!checkboxesState.find((checkbox) => {
						if (!checkbox.isChecked) {
							return false;
						}

						// do calculations only if checkbox is checked
						return PositionExcComb[d.exc] === checkbox.value.toLowerCase();
					});
				} else {
					return isAllSelected;
				}
			});
		});
	}

	function applyFilter() {
		const filteredData = groupData(props.data[0], props.filterInputParams.isToggleOn);
		props.onFilter(filterData(filteredData, checkboxesState));
		setIsDropdownOpen(false);
	}

	function reset() {
		//ob mobile filters will be applied on clicking apply filter, else it will be restored to prev State
		if (deviceState.isMobile) {
			setcheckboxesState(filterDropDownOption);
			setIsAllSelected(true);
		}
		setIsDropdownOpen(false);
	}

	return (
		<div className={"navigation_dropdown filter " + (!isAllSelected ? " active" : "")}>
			{/* dropdown toggle on click of button */}
			<EdButton
				value={
					<>
						<i className="filter edel-icon-filter btn_icon" />
						{!deviceState.isMobile && <span className="fltr_lbl">Filter</span>}
					</>
				}
				btnTyp="blue-link"
				onClick={() => setIsDropdownOpen(true)}
			/>

			{/* if isDropdownOpen is true the the dropdown will show */}
			{isDropdownOpen && (
				<>
					<div className="dropdown_overlay" onClick={() => reset()} />
					<ul className="dropdown_content">
						{/* toggle the radio button */}
						{props.filterInputParams.showOpenOrderTgl && (
							<>
								<li className="dropdown_item">
									<Toggle name="toggle1" isOn={props.filterInputParams.isToggleOn} onChange={onSwitchOnOff}>
										Open orders on top
									</Toggle>
								</li>
								<hr className="slim_line" />
							</>
						)}
						{checkboxesState.length ? (
							<div className="ObddOpts">
								<li className="dropdown_item">
									<ObCheckbox name="chkbox-filter" checked={isAllSelected} onChange={() => onChecked(-1)}>
										All Orders
									</ObCheckbox>
								</li>
								{/* checkboxes check /uncheck */}
								{checkboxesState.map((checkbox, index) => (
									<li className="dropdown_item" key={index}>
										<ObCheckbox
											name="chkbox-filter"
											checked={checkbox.isChecked}
											onChange={() => onChecked(index)}
											disabled={isAllSelected}
										>
											{checkbox.value}
										</ObCheckbox>
									</li>
								))}
							</div>
						) : (
							<></>
						)}
						{deviceState.isMobile && (
							<div className="fltr_btn">
								<EdButton value="Close" btnTyp="secondary" className="mob_fltr" onClick={() => reset()} />
								<EdButton value=" Apply Filter" btnTyp="primary" className="mob_fltr" onClick={applyFilter} />
							</div>
						)}
					</ul>
				</>
			)}
		</div>
	);
};
export default PositionFilter;
